  (function () {
    if (customElements.get('quantity-panel-selector-exa')) return;
    var variantRequestCache = new Map();

    customElements.define(
      'quantity-panel-selector-exa',
      class QuantityPanelSelectorExa extends HTMLElement {
        connectedCallback() {
          if (this._qpsConnected) return;
          this._qpsConnected = true;
          this.sectionId = this.getAttribute('data-section');
          this.moneyFormat = this.getAttribute('data-money-format') || '';
          this.shopCurrency = (this.getAttribute('data-shop-currency') || '').toUpperCase();
          this.presentmentCurrency = (this.getAttribute('data-presentment-currency') || '').toUpperCase();
          this.nativePresentmentCurrency = Boolean(this.shopCurrency && this.presentmentCurrency && this.shopCurrency !== this.presentmentCurrency);
          this.fixedDiscountRate = this.nativePresentmentCurrency
            ? Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1
            : 1;
          this.defaultOption = parseInt(this.getAttribute('data-default-option'), 10) || 1;
          this.syncPdpPrices = this.getAttribute('data-update-pdp-prices') === 'true';
          this.updatePdpPrices = true;
          this.updatePrices = true;
          this.hasVariants = false;
          this.variantSelects = [];
          this.selectedVariants = {};
          this.formVariants = [];
          this.subDiscount = 0;
          this.subDiscountType = null;
          this.offerPrices = {
            offer_1: { price: 0, compare_price: 0, regular_price: 0 },
            offer_2: { price: 0, compare_price: 0, regular_price: 0 },
            offer_3: { price: 0, compare_price: 0, regular_price: 0 },
            offer_4: { price: 0, compare_price: 0, regular_price: 0 }
          };
          this.hydrateSelectorVariantPickers();
          this.cacheNodes();
          this.initVariants();
          this.bindListeners();
          this.initOfferPrices();
          this.applyDefaultChecked();
          this.applyState(false);
          this.hydrateShopCurrencyPrices().catch(function () {});
          if (this.hasVariants) {
            this.getVariantData()
              .then(() => {
                if (!this.isConnected) return;
                this.variantSelects.forEach((item) => this.refreshVariantOptions(item));
              })
              .catch(() => {
                this.variantSelects.forEach((item) => {
                  item.querySelectorAll('.quantity-panel-selector-exa__variant-select').forEach(function (select) {
                    select.disabled = true;
                  });
                });
              });
          }
          if (window.customElements && customElements.whenDefined) {
            customElements.whenDefined('quantity-break-upsells').then(() => {
              this.syncPanelGifts();
            });
          }
        }

        hydrateSelectorVariantPickers() {
          var template = this.querySelector('template[data-selector-variant-template]');
          if (!template || !template.content) return;
          var source = template.content.querySelector('.quantity-panel-selector-exa__variant-pickers');
          if (!source) {
            template.remove();
            return;
          }
          var showForQuantityOne = this.getAttribute('data-selector-variant-pickers-on-one') === 'true';
          this.querySelectorAll('.quantity-panel-selector-exa__option .quantity-panel-selector-exa__variant-pickers').forEach(function (picker) {
            picker.remove();
          });
          this.querySelectorAll('.quantity-panel-selector-exa__option').forEach(function (row) {
            var quantity = parseInt(row.getAttribute('data-quantity'), 10) || 0;
            var group = row.querySelector('.quantity-panel-selector-exa__panel-group[data-panel-group]');
            if (!group || quantity < 1 || (quantity === 1 && !showForQuantityOne)) return;
            var picker = source.cloneNode(true);
            var firstItem = picker.querySelector('.quantity-panel-selector-exa__variant-item');
            if (!firstItem) return;
            var itemTemplate = firstItem.cloneNode(true);
            var labelTemplate = picker.getAttribute('data-item-label-template') || '';
            for (var index = 0; index < quantity; index += 1) {
              var item = index === 0 ? firstItem : itemTemplate.cloneNode(true);
              item.setAttribute('data-select-index', String(index));
              var number = item.querySelector('.quantity-panel-selector-exa__variant-number');
              if (number && labelTemplate) {
                number.innerHTML = labelTemplate.replace(/\[index\]/g, String(index + 1));
              }
              var itemName = number ? number.textContent.trim() : String(index + 1);
              item.querySelectorAll('.quantity-panel-selector-exa__variant-select').forEach(function (select) {
                var optionName = select.getAttribute('data-option-name') || '';
                select.setAttribute('aria-label', optionName + ' — ' + itemName);
              });
              if (index > 0) picker.appendChild(item);
            }
            group.insertBefore(picker, group.firstChild);
          });
          template.remove();
        }

        cacheNodes() {
          this.rows = Array.from(this.querySelectorAll('.quantity-panel-selector-exa__option'));
          this.style.setProperty('--qps-panel-count', String(Math.max(1, this.rows.length)));
          this.inputs = Array.from(this.querySelectorAll('input[name="quantity"]'));
          this.labels = Array.from(this.querySelectorAll('.quantity-break'));
          this.panelGroups = Array.from(this.querySelectorAll('.quantity-panel-selector-exa__panel-group[data-panel-group]'));
          this.variantSelects = Array.from(this.querySelectorAll('.quantity-break__selector-item'));
          this.hasVariants = this.variantSelects.length > 0;
          var checked = this.inputs.filter(function (input) { return input.checked; })[0] || this.inputs[0];
          this.selectedQuantity = checked ? parseInt(checked.value, 10) || 1 : 1;
          this.selectedOffer = checked ? parseInt((checked.getAttribute('data-input') || 'input_1').replace('input_', ''), 10) || 1 : 1;
          this.panelGroups.forEach(function (group) {
            group.setAttribute('data-has-panels', group.childElementCount > 0 ? 'true' : 'false');
          });
        }

        applyDefaultChecked() {
          var checked = this.inputs.filter(function (input) { return input.checked; })[0];
          if (checked) return;
          var preferred = this.inputs.filter((input) => {
            return parseInt((input.getAttribute('data-input') || '').replace('input_', ''), 10) === this.defaultOption;
          })[0] || this.inputs[0];
          if (preferred) preferred.checked = true;
        }

        bindListeners() {
          this.inputs.forEach((input) => {
            if (input._qpsBound) return;
            input._qpsBound = true;
            input.addEventListener('change', () => {
              if (!input.checked) return;
              this.applyState(true);
            });
          });
          this.variantSelects.forEach((item) => {
            if (item._qpsVariantBound) return;
            item._qpsVariantBound = true;
            item.addEventListener('change', (event) => {
              if (!event.target.matches('.quantity-panel-selector-exa__variant-select')) return;
              this.handleVariantChange(item, event.target);
            });
          });
        }

        initVariants() {
          this.selectedVariants = {};
          this.rows.forEach((row) => {
            var label = row.querySelector('.quantity-panel-selector-exa__option-button');
            if (!label) return;
            var inputKey = label.getAttribute('data-input') || '';
            var selected = Array.from(row.querySelectorAll('.quantity-break__selector-item')).map(function (item) {
              var values = Array.from(item.querySelectorAll('.quantity-panel-selector-exa__variant-select')).map(function (select) {
                return select.value;
              });
              item.setAttribute('data-selected-options', JSON.stringify(values));
              return item.getAttribute('data-selected-id');
            }).filter(Boolean);
            if (selected.length) this.selectedVariants[inputKey] = selected;
          });
          var active = this.selectedVariants['input_' + this.selectedOffer] || [];
          this.formVariants = active.slice();
        }

        getVariantRequestUrl(currency) {
          var picker = this.querySelector('.quantity-panel-selector-exa__variant-pickers[data-product-url]');
          var productUrl = picker ? picker.getAttribute('data-product-url') : this.getAttribute('data-product-url') || '';
          if (!productUrl) return '';
          var requestUrl = productUrl.split('?')[0].replace(/\.js$/, '') + '.js';
          if (currency) requestUrl += '?currency=' + encodeURIComponent(currency);
          return requestUrl;
        }

        requestVariantData(requestUrl) {
          if (!requestUrl) return Promise.resolve([]);
          var request = variantRequestCache.get(requestUrl);
          if (!request) {
            request = fetch(requestUrl, {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            }).then(function (response) {
              if (!response.ok) throw new Error('Unable to load product variants.');
              return response.json();
            }).then(function (productData) {
              return Array.isArray(productData.variants) ? productData.variants : [];
            });
            variantRequestCache.set(requestUrl, request);
          }
          return request;
        }

        getVariantData() {
          if (this.variantData) return Promise.resolve(this.variantData);
          if (this.variantDataPromise) return this.variantDataPromise;
          this.variantDataPromise = this.requestVariantData(this.getVariantRequestUrl()).then((variants) => {
            this.variantData = variants;
            return variants;
          });
          return this.variantDataPromise;
        }

        hydrateShopCurrencyPrices() {
          var hasFixedDiscount = this.labels.some(function (label) {
            return (parseFloat(label.getAttribute('data-fixed-discount')) || 0) > 0;
          });
          if (!this.nativePresentmentCurrency || !hasFixedDiscount) return Promise.resolve([]);
          return this.requestVariantData(this.getVariantRequestUrl(this.shopCurrency)).then((variants) => {
            if (!this.isConnected || !variants.length) return variants;
            this.shopCurrencyVariants = variants;
            var baseVariantId = this.getAttribute('data-base-variant-id') || '';
            var baseVariant = variants.find(function (variant) {
              return String(variant.id) === String(baseVariantId);
            }) || variants[0];
            this.shopCurrencyBasePrice = Number(baseVariant && baseVariant.price) || 0;
            this.initOfferPrices();
            if (this.variantData && this.variantData.length) {
              this.rows.forEach((row) => this.updateOfferFromVariants(row));
            }
            this.updateInnerPrices();
            this.updateDisplayedPdpPrices();
            return variants;
          });
        }

        getShopCurrencyVariantPrice(variantId) {
          if (!this.shopCurrencyVariants || !this.shopCurrencyVariants.length) return 0;
          var variant = this.shopCurrencyVariants.find(function (item) {
            return String(item.id) === String(variantId);
          });
          return Number(variant && variant.price) || 0;
        }

        calculateFixedDiscountPrice(presentmentRegularPrice, sourceRegularPrice, percentageLeft, fixedDiscount) {
          if (fixedDiscount > 0 && sourceRegularPrice > 0 && this.nativePresentmentCurrency) {
            var sourcePrice = Math.max(0, sourceRegularPrice * percentageLeft - fixedDiscount);
            return Math.round(sourcePrice * this.fixedDiscountRate);
          }
          return Math.max(0, presentmentRegularPrice * percentageLeft - Math.round(fixedDiscount * this.fixedDiscountRate));
        }

        variantMatches(variant, values) {
          if (!variant || !Array.isArray(variant.options)) return false;
          return values.every(function (value, index) {
            return String(variant.options[index]) === String(value);
          });
        }

        syncCurrentVariant(variant) {
          if (!variant || !Array.isArray(variant.options)) return;
          this.variantSelects.forEach((item) => {
            item.setAttribute('data-selected-id', String(variant.id));
            item.setAttribute('data-selected-options', JSON.stringify(variant.options));
            item.querySelectorAll('.quantity-panel-selector-exa__variant-select').forEach(function (select, index) {
              var nextValue = variant.options[index];
              if (nextValue == null) return;
              var exists = Array.from(select.options).some(function (option) {
                return String(option.value) === String(nextValue);
              });
              if (exists) select.value = String(nextValue);
            });
          });
          this.initVariants();
          if (this.variantData && this.variantData.length) {
            this.variantSelects.forEach((item) => this.refreshVariantOptions(item));
          }
        }

        refreshVariantOptions(item) {
          if (!item || !this.variantData || !this.variantData.length) return;
          var selects = Array.from(item.querySelectorAll('.quantity-panel-selector-exa__variant-select'));
          var values = selects.map(function (select) { return select.value; });
          var picker = item.closest('.quantity-panel-selector-exa__variant-pickers');
          var skipUnavailable = picker && picker.getAttribute('data-skip-unavailable') === 'true';
          var unavailableTemplate = window.variantStrings && window.variantStrings.unavailable_with_option;
          selects.forEach((select, optionIndex) => {
            Array.from(select.options).forEach((option) => {
              var optionValue = option.getAttribute('data-value') || option.value;
              var candidateValues = values.slice();
              candidateValues[optionIndex] = optionValue;
              var candidates = this.variantData.filter(function (variant) {
                if (!variant || !Array.isArray(variant.options)) return false;
                return candidateValues.slice(0, optionIndex + 1).every(function (value, index) {
                  return String(variant.options[index]) === String(value);
                });
              });
              var exists = candidates.length > 0;
              var available = candidates.some(function (variant) { return variant.available !== false; });
              var unavailable = exists && !available;
              var hide = !option.selected && (!exists || (skipUnavailable && unavailable));
              option.classList.toggle('non-existent', !exists);
              option.classList.toggle('unavailable', unavailable);
              option.disabled = hide;
              option.hidden = hide;
              option.textContent = unavailable && unavailableTemplate
                ? unavailableTemplate.replace('[value]', optionValue)
                : optionValue;
            });
          });
        }

        findVariantForSelection(values, changedIndex, skipUnavailable) {
          var exact = this.variantData.find((variant) => this.variantMatches(variant, values));
          if (exact && (!skipUnavailable || exact.available !== false)) return exact;
          var changedValue = values[changedIndex];
          return this.variantData.find(function (variant) {
            if (variant.available === false || String(variant.options[changedIndex]) !== String(changedValue)) return false;
            return values.slice(0, changedIndex).every(function (value, index) {
              return String(variant.options[index]) === String(value);
            });
          }) || this.variantData.find(function (variant) {
            return variant.available !== false;
          }) || exact;
        }

        restoreVariantItem(item) {
          var selectedOptions = [];
          try {
            selectedOptions = JSON.parse(item.getAttribute('data-selected-options') || '[]');
          } catch (error) {
            selectedOptions = [];
          }
          item.querySelectorAll('.quantity-panel-selector-exa__variant-select').forEach(function (select, index) {
            if (selectedOptions[index] != null) select.value = selectedOptions[index];
          });
        }

        async handleVariantChange(item, changedSelect) {
          var variants;
          try {
            variants = await this.getVariantData();
          } catch (error) {
            this.restoreVariantItem(item);
            return;
          }
          if (!variants.length || !item.isConnected) {
            this.restoreVariantItem(item);
            return;
          }
          var selects = Array.from(item.querySelectorAll('.quantity-panel-selector-exa__variant-select'));
          var values = selects.map(function (select) { return select.value; });
          var changedIndex = selects.indexOf(changedSelect);
          var picker = item.closest('.quantity-panel-selector-exa__variant-pickers');
          var skipUnavailable = picker && picker.getAttribute('data-skip-unavailable') === 'true';
          var variant = this.findVariantForSelection(values, changedIndex, skipUnavailable);
          if (!variant) return;
          if (!this.variantMatches(variant, values)) {
            selects.forEach(function (select, index) {
              select.value = variant.options[index];
            });
          }
          item.setAttribute('data-selected-id', String(variant.id));
          item.setAttribute('data-selected-options', JSON.stringify(variant.options));
          var row = item.closest('.quantity-panel-selector-exa__option');
          var label = row ? row.querySelector('.quantity-panel-selector-exa__option-button') : null;
          var inputKey = label ? label.getAttribute('data-input') : '';
          var itemIndex = parseInt(item.getAttribute('data-select-index'), 10) || 0;
          if (!this.selectedVariants[inputKey]) this.selectedVariants[inputKey] = [];
          this.selectedVariants[inputKey][itemIndex] = String(variant.id);
          if (inputKey === 'input_' + this.selectedOffer) {
            this.formVariants = this.selectedVariants[inputKey].slice();
          }
          this.refreshVariantOptions(item);
          this.updateOfferFromVariants(row);
        }

        updateOfferFromVariants(row) {
          if (!row || !this.variantData || !this.variantData.length) return;
          var picker = row.querySelector('.quantity-panel-selector-exa__variant-pickers');
          if (!picker || picker.getAttribute('data-update-variant-prices') !== 'true') return;
          var label = row.querySelector('.quantity-panel-selector-exa__option-button');
          if (!label) return;
          var inputKey = label.getAttribute('data-input') || '';
          var selectedIds = this.selectedVariants[inputKey] || [];
          var quantity = parseInt(label.getAttribute('data-quantity'), 10) || 1;
          if (selectedIds.length !== quantity) return;
          var selected = selectedIds.map((id) => {
            return this.variantData.find(function (variant) { return String(variant.id) === String(id); });
          });
          if (selected.some(function (variant) { return !variant; })) return;
          var regularPrice = selected.reduce(function (total, variant) {
            return total + (Number(variant.price) || 0);
          }, 0);
          var compareMode = label.getAttribute('data-compare-mode');
          var comparePrice = selected.reduce(function (total, variant) {
            var price = Number(variant.price) || 0;
            var compare = Number(variant.compare_at_price) || 0;
            return total + (compareMode === 'compare_price' && compare > price ? compare : price);
          }, 0);
          var percentageLeft = parseFloat(label.getAttribute('data-percentage-left'));
          if (!isFinite(percentageLeft)) percentageLeft = 1;
          var fixedDiscount = parseFloat(label.getAttribute('data-fixed-discount')) || 0;
          var sourceRegularPrice = selectedIds.reduce((total, id) => {
            return total + this.getShopCurrencyVariantPrice(id);
          }, 0);
          var price = this.calculateFixedDiscountPrice(regularPrice, sourceRegularPrice, percentageLeft, fixedDiscount);
          var offer = inputKey.replace('input_', '');
          this.offerPrices['offer_' + offer] = {
            price: price,
            compare_price: comparePrice,
            regular_price: regularPrice
          };
          this.updateLabelPrices(label);
          if (parseInt(offer, 10) === this.selectedOffer) this.updateDisplayedPdpPrices();
          this.notifyExternalPricingChange();
        }

        notifyExternalPricingChange() {
          this.dispatchEvent(new CustomEvent('quantity-panel-selector-exa:change', {
            bubbles: true,
            detail: {
              sectionId: this.sectionId,
              quantity: this.selectedQuantity,
              offer: this.selectedOffer
            }
          }));
        }

        formatMoney(cents) {
          var value = Number(cents);
          if (!isFinite(value)) value = 0;
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            return window.Shopify.formatMoney(value, this.moneyFormat);
          }
          var format = this.moneyFormat || '$' + '{' + '{amount}' + '}';
          var amount = value / 100;
          function numberWithDelimiters(number, precision, thousands, decimal) {
            precision = precision == null ? 2 : precision;
            thousands = thousands || ',';
            decimal = decimal || '.';
            var parts = number.toFixed(precision).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return parts.join(decimal);
          }
          return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, token) {
            switch (token) {
              case 'amount':
                return numberWithDelimiters(amount, 2);
              case 'amount_no_decimals':
                return numberWithDelimiters(amount, 0);
              case 'amount_with_comma_separator':
                return numberWithDelimiters(amount, 2, '.', ',');
              case 'amount_no_decimals_with_comma_separator':
                return numberWithDelimiters(amount, 0, '.', ',');
              default:
                return numberWithDelimiters(amount, 2);
            }
          });
        }

        applySubTo(cents) {
          if (!this.subDiscountType || !cents) return cents;
          if (this.subDiscountType === 'fixed_amount') return Math.max(0, cents - this.subDiscount);
          if (this.subDiscountType === 'percentage') return Math.round(cents * (100 - this.subDiscount) / 100);
          if (this.subDiscountType === 'price') return this.subDiscount;
          return cents;
        }

        initOfferPrices() {
          var basePrice = parseInt(this.getAttribute('data-base-price'), 10) || 0;
          this.labels.forEach((label) => {
            var offer = (label.getAttribute('data-input') || 'input_1').replace('input_', '');
            var qty = parseFloat(label.getAttribute('data-quantity')) || 1;
            var percentageLeft = parseFloat(label.getAttribute('data-percentage-left'));
            if (!isFinite(percentageLeft)) percentageLeft = 1;
            var fixedDiscount = parseFloat(label.getAttribute('data-fixed-discount')) || 0;
            var presentmentRegularPrice = basePrice * qty;
            var sourceRegularPrice = (this.shopCurrencyBasePrice || 0) * qty;
            var price = this.calculateFixedDiscountPrice(presentmentRegularPrice, sourceRegularPrice, percentageLeft, fixedDiscount);
            var compareUnit = parseInt(label.getAttribute('data-base-compare-price'), 10) || basePrice;
            var comparePrice = compareUnit * qty;
            var regularPrice = basePrice * qty;
            this.offerPrices['offer_' + offer] = {
              price: price,
              compare_price: comparePrice,
              regular_price: regularPrice
            };
          });
        }

        getOfferValues(label) {
          if (!label) return null;
          var offer = (label.getAttribute('data-input') || 'input_1').replace('input_', '');
          var qty = parseFloat(label.getAttribute('data-quantity')) || 1;
          var prices = this.offerPrices['offer_' + offer] || { price: 0, compare_price: 0, regular_price: 0 };
          var price = this.applySubTo(prices.price);
          var regular = prices.regular_price || prices.compare_price || price;
          var compare = prices.compare_price || regular;
          var amount = Math.max(0, regular - price);
          var rounded = Math.round(amount / 100) * 100;
          var percent = regular > 0 ? Math.round((amount * 100) / regular) : 0;
          return {
            quantity: String(qty),
            price: this.formatMoney(price),
            compare: this.formatMoney(compare),
            amount: this.formatMoney(amount),
            rounded: this.formatMoney(rounded),
            priceEach: this.formatMoney(price / qty),
            compareEach: this.formatMoney(compare / qty),
            percent: percent + '%'
          };
        }

        fillTemplate(template, values) {
          if (!template || !values) return template || '';
          return template
            .replace(/\[quantity\]/g, values.quantity)
            .replace(/\[price\]/g, values.price)
            .replace(/\[compare_price\]/g, values.compare)
            .replace(/\[amount_saved\]/g, values.amount)
            .replace(/\[amount_saved_rounded\]/g, values.rounded)
            .replace(/\[price_each\]/g, values.priceEach)
            .replace(/\[compare_price_each\]/g, values.compareEach)
            .replace(/\[percentage_saved\]/g, values.percent);
        }

        updateLabelPrices(label) {
          var values = this.getOfferValues(label);
          if (!values) return;
          var elements = Array.from(label.querySelectorAll('.variant-price-update'));
          var option = label.closest('.quantity-panel-selector-exa__option');
          if (option) {
            Array.from(option.children).forEach((el) => {
              if (
                el.classList.contains('variant-price-update') &&
                (el.classList.contains('quantity-panel-selector-exa__badge') ||
                  el.classList.contains('quantity-panel-selector-exa__outside-text'))
              ) {
                elements.push(el);
              }
            });
          }
          elements.forEach((el) => {
            var template = el.getAttribute('data-text') || '';
            var html = this.fillTemplate(template, values);
            var contentTarget = el;
            if (el.classList.contains('quantity-panel-selector-exa__badge')) {
              contentTarget = el.querySelector('.quantity-panel-selector-exa__badge-text') || el;
            }
            contentTarget.innerHTML = html;
            if (html) {
              el.classList.remove('is-empty');
              el.removeAttribute('hidden');
            } else {
              el.classList.add('is-empty');
              el.setAttribute('hidden', '');
            }
          });
        }

        updateInnerPrices() {
          this.labels.forEach((label) => this.updateLabelPrices(label));
        }

        updateDisplayedPdpPrices() {
          if (!this.syncPdpPrices) return;
          if (typeof window.updatePdpPrices !== 'function') return;
          var prices = this.offerPrices['offer_' + this.selectedOffer];
          if (!prices) return;
          window.updatePdpPrices(this.applySubTo(prices.price), prices.compare_price, this.sectionId, this.moneyFormat);
        }

        getGroupOption(group) {
          var index = group ? parseInt(group.getAttribute('data-option-index'), 10) : 0;
          return index > 0 ? index : 0;
        }

        capturePanelGroupHeights() {
          this.panelGroups.forEach(function (group) {
            group._qpsPreviousHeight = group.hasAttribute('hidden') ? 0 : group.scrollHeight;
          });
        }

        shouldReduceMotion() {
          return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        resetPanelGroupAnimation(group) {
          if (!group) return;
          if (group._qpsAnimationEnd) {
            group.removeEventListener('transitionend', group._qpsAnimationEnd);
            group._qpsAnimationEnd = null;
          }
          if (group._qpsAnimationFrame) {
            window.cancelAnimationFrame(group._qpsAnimationFrame);
            group._qpsAnimationFrame = null;
          }
        }

        setPanelGroupOpen(group, open, animate) {
          if (!group) return;
          var isHidden = group.hasAttribute('hidden');
          if (open && !isHidden && group.getAttribute('data-qps-open') === 'true') return;
          if (!open && isHidden) return;
          var previousHeight = group._qpsPreviousHeight || 0;
          group._qpsPreviousHeight = 0;

          this.resetPanelGroupAnimation(group);
          group.setAttribute('data-qps-open', open ? 'true' : 'false');

          if (!animate || this.shouldReduceMotion()) {
            if (open) group.removeAttribute('hidden');
            else group.setAttribute('hidden', '');
            group.style.height = '';
            group.style.opacity = '';
            group.style.paddingTop = '';
            group.style.paddingBottom = '';
            return;
          }

          if (open) {
            group.removeAttribute('hidden');
            group.style.height = '0px';
            group.style.opacity = '0';
            group.style.paddingTop = '0px';
            group.style.paddingBottom = '0px';
            group.offsetHeight;
            group.style.paddingTop = '';
            group.style.paddingBottom = '';
            var targetHeight = group.scrollHeight;
            group._qpsAnimationFrame = window.requestAnimationFrame(function () {
              group._qpsAnimationFrame = null;
              group.style.height = targetHeight + 'px';
              group.style.opacity = '1';
            });
            group._qpsAnimationEnd = function (event) {
              if (event.target !== group || event.propertyName !== 'height') return;
              group.removeEventListener('transitionend', group._qpsAnimationEnd);
              group._qpsAnimationEnd = null;
              if (group.getAttribute('data-qps-open') === 'true') {
                group.style.height = '';
                group.style.opacity = '';
                group.style.paddingTop = '';
                group.style.paddingBottom = '';
              }
            };
            group.addEventListener('transitionend', group._qpsAnimationEnd);
            return;
          }

          var startHeight = previousHeight > 0 ? previousHeight : group.scrollHeight;
          group.style.height = startHeight + 'px';
          group.style.opacity = '1';
          group.style.paddingTop = '';
          group.style.paddingBottom = '';
          group.offsetHeight;
          group._qpsAnimationFrame = window.requestAnimationFrame(function () {
            group._qpsAnimationFrame = null;
            group.style.height = '0px';
            group.style.opacity = '0';
            group.style.paddingTop = '0px';
            group.style.paddingBottom = '0px';
          });
          group._qpsAnimationEnd = function (event) {
            if (event.target !== group || event.propertyName !== 'height') return;
            group.removeEventListener('transitionend', group._qpsAnimationEnd);
            group._qpsAnimationEnd = null;
            if (group.getAttribute('data-qps-open') === 'false') {
              group.setAttribute('hidden', '');
              group.style.height = '';
              group.style.opacity = '';
              group.style.paddingTop = '';
              group.style.paddingBottom = '';
            }
          };
          group.addEventListener('transitionend', group._qpsAnimationEnd);
        }

        syncPanelGifts() {
          var selectedOption = this.selectedOffer;
          this.querySelectorAll('quantity-break-upsells').forEach((upsell) => {
            var row = upsell.closest('.quantity-panel-selector-exa__option');
            var panelOption = row ? parseInt(row.getAttribute('data-option-index'), 10) : 0;
            var active = panelOption === selectedOption;
            upsell.querySelectorAll('.quantity-break__upsell').forEach((item) => {
              var defaultSelected = item.getAttribute('data-default-selected') || 'true';
              item.setAttribute('data-selected', active ? defaultSelected : 'false');
              if (item.hasAttribute('aria-checked')) item.setAttribute('aria-checked', active ? defaultSelected : 'false');
              if (item.getAttribute('data-qpg-inherit') === 'true') {
                item.setAttribute('data-min-quantity', String(this.selectedQuantity));
              }
            });
            if (typeof upsell.unlockGifts === 'function') {
              upsell.unlockGifts(this.selectedQuantity, false);
            }
          });
        }

        applyState(animate) {
          var checked = this.inputs.filter(function (input) { return input.checked; })[0] || this.inputs[0];
          if (!checked) return;
          if (!checked.checked) checked.checked = true;
          this.selectedQuantity = parseInt(checked.value, 10) || 1;
          this.selectedOffer = parseInt((checked.getAttribute('data-input') || 'input_1').replace('input_', ''), 10) || 1;
          if (this.hasVariants) {
            var selected = this.selectedVariants['input_' + this.selectedOffer] || [];
            this.formVariants = selected.length === this.selectedQuantity ? selected.slice() : [];
          } else {
            this.formVariants = [];
          }
          if (animate) this.capturePanelGroupHeights();
          this.rows.forEach((row) => {
            var isSelected = parseInt(row.getAttribute('data-option-index'), 10) === this.selectedOffer;
            row.setAttribute('data-selected', isSelected ? 'true' : 'false');
            var label = row.querySelector('.quantity-panel-selector-exa__option-button');
            if (label) {
              label.setAttribute('aria-checked', isSelected ? 'true' : 'false');
              label.setAttribute('aria-expanded', isSelected ? 'true' : 'false');
            }
          });
          this.panelGroups.forEach((group) => {
            var hasPanels = group.getAttribute('data-has-panels') === 'true';
            var show = hasPanels && this.getGroupOption(group) === this.selectedOffer;
            this.setPanelGroupOpen(group, show, animate);
          });
          this.updateInnerPrices();
          this.syncPanelGifts();
          this.updateDisplayedPdpPrices();
          this.notifyExternalPricingChange();
        }
      }
    );
  })();
